import requests from './httpService';
const CouponService = {
  getAllCoupon(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return requests.get(`/coupon/list${queryString ? `?${queryString}` : ''}`);
  },
   getAllActiveCoupon(body) {
    return requests.post(`/coupon/activelist`,body);
  },
  getCoupon(body){
    return requests.post('/coupon/get',body); 
  },
  creteCoupon(body){
    return requests.post('/coupon/add',body); 
  },
  getAllCouponById(id,body){
    return requests.post(`/coupon/list/${id}`,body); 
  },
  deleteCoupon(body){
    return requests.delete(`/coupon/${body._id}`); 
    
  },
  getCouponById(id) {
    return requests.get(`/coupon/${id}` );
  },
 
  findCouponList(body){
    return requests.post(`/coupon/find`,body); 
  },
  upadeCoupon(body) {
    return requests.put(`/coupon/${body._id}`,body); 
  }, 
  
  // Validate/apply a coupon publicly for a booking flow
  // Expects: { couponCode, profileRegistrationId, parkId, orderAmount }
  validateCoupon(body){
    return requests.post('/coupon/public/apply', body);
  },
  
  
};

export default CouponService;
